/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * Base class for commands that replace entire nodes.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class ReplaceNodeCommand<T extends Node> extends AbstractCommand {
    public _nodePath : NodePath;

    public _new : any;

    public _old : any;

    public constructor(old? : any, replacement? : any) {
        if(((old != null) || old === null) && ((replacement != null) || replacement === null)) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._new===undefined) this._new = null;
            if(this._old===undefined) this._old = null;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._new===undefined) this._new = null;
            if(this._old===undefined) this._old = null;
            (() => {
                this._nodePath = Library.createNodePath(old);
                this._new = Library.writeNode(replacement);
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._new===undefined) this._new = null;
            if(this._old===undefined) this._old = null;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._new===undefined) this._new = null;
            if(this._old===undefined) this._old = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AbstractReplaceNodeCommand] Executing.");
        this._old = null;
        let oldNode : T = <T><any>this._nodePath.resolve(document);
        if(this.isNullOrUndefined(oldNode)) {
            return;
        }
        this._old = Library.writeNode(oldNode);
        this.removeNode(document, oldNode);
        let newNode : T = this.readNode(document, this._new);
        this.addNode(document, newNode);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AbstractReplaceNodeCommand] Reverting.");
        if(this.isNullOrUndefined(this._old)) {
            return;
        }
        let node : T = <T><any>this._nodePath.resolve(document);
        if(this.isNullOrUndefined(node)) {
            return;
        }
        this.removeNode(document, node);
        let restoreNode : T = this.readNode(document, this._old);
        this.addNode(document, restoreNode);
    }

    /**
     * Removes the given node from the data model.
     * @param {Document} doc
     * @param {Node} node
     */
    abstract removeNode(doc : Document, node : T);

    /**
     * Adds the given node to the data model.
     * @param {Document} doc
     * @param {Node} node
     */
    abstract addNode(doc : Document, node : T);

    /**
     * Unmarshalls a node into the appropriate type.
     * @param {*} node
     * @param {Document} doc
     * @return {Node}
     */
    abstract readNode(doc : Document, node : any) : T;
}
ReplaceNodeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand";
ReplaceNodeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




